import JoinForm from './JoinForm';
import JoinFormContainer from './JoinForm.container';

export default JoinFormContainer(JoinForm);
